export enum ProductUnit {
  HOUR = 'HOUR',
  DAY = 'DAY',
  QUARTER = 'QUARTER',
  MONTH = 'MONTH',
  YEAR = 'YEAR',
  ITEM = 'ITEM',
  MEDIUM = 'MEDIUM',
  SMALL = 'SMALL',
  LARGE = 'LARGE',
}

export enum ProductUnitQuantity {
  MONTH = 1,
  QUARTER = 3,
  YEAR = 12,
}

export enum ProductCode {
  CARD = 'card',
}

export enum ProductName {
  OPEN_SPACE = 'open space',
}

export enum CategoryCode {
  SPACE = 'space',
  REFRESHMENT = 'refreshment',
  SUBSCRIPTION = 'subscription',
  PACKAGE = 'package',
}

export const SubscriptionPriceUnits = [
  ProductUnit.MONTH,
  ProductUnit.QUARTER,
  ProductUnit.YEAR,
];
